import { Stack, Text } from '@mantine/core';
import { modals } from '@mantine/modals';

/** The selection bar's **Delete…**: spells out the irreversible scope, then runs `onConfirm`. */
export const confirmDeleteSelection = (summary: string, onConfirm: () => void) => {
    modals.openConfirmModal({
        title: <Text fw={600}>Delete from master?</Text>,
        size: 'min(520px, 100%)',
        children: (
            <Stack gap="sm">
                <Text size="sm">{summary} will be deleted from master.</Text>
                <Text size="sm" fw={600}>
                    No environment records will be deleted.
                </Text>
                <Text fz="xs" c="dimmed">
                    After the next pull, matching environment records will appear as Env only and can be adopted into
                    master again.
                </Text>
            </Stack>
        ),
        labels: { confirm: 'Delete master', cancel: 'Cancel' },
        confirmProps: { color: 'red' },
        onConfirm,
    });
};
